module.exports = __webpack_public_path__ + "static/media/blue-close-circle.4eb69462.svg";